/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_Delete_ConfirmInputs */



/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Standards_Preset_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_delete_confirm = /** @type {((inputs?: Standards_Preset_Delete_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Delete_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Delete")
	if (locale === "de") return /** @type {LocalizedString} */ ("Delete")
	if (locale === "it") return /** @type {LocalizedString} */ ("Delete")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Delete")
	if (locale === "es") return /** @type {LocalizedString} */ ("Delete")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Delete")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Delete")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Delete")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Delete")
	return /** @type {LocalizedString} */ ("Delete")
});